import React from 'react';

const Checkbox = ({ name, label, required = true, url, onFieldChange }) => {
  const className = `field field--${name}`;
  const labelLinkText = label.substring(label.lastIndexOf('{') + 1, label.lastIndexOf('}'));

  return (
    <div className={className}>
      <input
        id={name}
        name={name}
        type="checkbox"
        required={required}
        onChange={e => onFieldChange(e.target, e.target.value)}
        className="field__hidden"
      />
      <label className="field__control" htmlFor={name}>
        <span>
          {label.replace(`{${labelLinkText}}`, ' ')}
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {labelLinkText}
            </a>
          ) : (
            labelLinkText
          )}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
